import { safeDefine } from "../../registration/safe-define.js";
import { CompatAudioSkinElement } from "../../presets/audio/compat-skin.js";
import "../../internal/skins/compat-audio/register.js";
//#region src/define/audio/compat-skin.ts
safeDefine(CompatAudioSkinElement);
//#endregion
